import { ISetEditValue, PropertyItem, Widget, WidgetProps, localText, sanitizeHtml } from "@serenity-is/corelib";
import { nsExtensions } from "../ServerTypes/Namespaces";

/**
* This is an editor widget but it only displays a text, not edits it.
*/
export class StaticTextBlock<P extends StaticTextBlockOptions = StaticTextBlockOptions> extends Widget<P> implements ISetEditValue {
    static override[Symbol.typeInfo] = this.registerEditor(nsExtensions, [ISetEditValue]);
    static override createDefaultElement() { return document.createElement("div"); }

    declare private value: string;

    constructor(props: WidgetProps<P>) {
        super(props);

        // hide the caption label for this editor if in a form. ugly hack
        if (this.options.hideLabel) {
            const label = this.domNode.closest('.field')?.querySelector('.caption') as HTMLLabelElement;
            label && (label.hidden = true);
        }

        this.updateElementContent();
    }

    private updateElementContent() {
        let txt = this.options.text ?? this.value;

        // if isLocalText is set, text is actually a local text key
        if (this.options.isLocalText)
            txt = localText(txt);

        // don't html encode if isHtml option is true
        if (this.options.isHtml)
            this.domNode.innerHTML = sanitizeHtml(txt);
        else
            this.domNode.textContent = txt;
    }

    /**
        * By implementing ISetEditValue interface, we allow this editor to display its field value.
        * But only do this when our text content is not explicitly set in options
        */
    public setEditValue(source: any, property: PropertyItem) {
        if (this.options.text == null) {
            this.value = this.options.text ?? source[property.name];
            this.updateElementContent();
        }
    }
}

export interface StaticTextBlockOptions {
    text: string;
    isHtml: boolean;
    isLocalText: boolean;
    hideLabel: boolean;
}
